import { render, staticRenderFns } from "./resultType.vue?vue&type=template&id=9d8cd650&"
import script from "./resultType.vue?vue&type=script&lang=js&"
export * from "./resultType.vue?vue&type=script&lang=js&"
import style0 from "./resultType.vue?vue&type=style&index=0&id=9d8cd650&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports